import { errorNotifier, successNotifier } from "../../../..";
import http, { AUTH_ROUTES } from "../../../../service/api";

export const getRandomTraders = async (setTraders, setLoading) => {
  try {
    const res = await http.get(
      AUTH_ROUTES.GET_RANDOM_TRADERS_OR_USERS()
    );
    setTraders(res?.data?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

export const addStory = async (payload, setLoading) => {
  try {
    const data = await http.post(AUTH_ROUTES.POST_STORIES, payload);
    setLoading(false);
    successNotifier("Story posted successfully");
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.message);
  }
};

export const getUserStories = async (setStories, setLoading) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_USER_STORIES);
    setStories(data?.data);
    setLoading && setLoading(false);
  } catch (e) {
    setLoading && setLoading(false);

  }
};

export const getFollowingStories = async (
  //setStories,
  setStoriesList,
  acct_type,
  setLoading
) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_FOLLOWING_STORIES);
    //setStories(data?.data?.data);
    setStoriesList(data?.data);
    setLoading && setLoading(false);
  } catch (e) {
    setLoading && setLoading(false);

  }
};

export const follow = async (userId, setLoading) => {
  try {
    const res = await http.put(AUTH_ROUTES.FOLLOW(userId));
    setLoading(false);
    successNotifier("You are now following this user");
    return res
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.message);
  }
};

export const unFollow = async (userId, setLoading) => {
  try {
    const res = await http.put(AUTH_ROUTES.UNFOLLOW(userId));
    setLoading(false);
    successNotifier("You have unfollowed this user");
    return res
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.message);
  }
};

export const getMyfollowers = async (userId) => {
  try {
    const response = await http.get(AUTH_ROUTES.FOLLOWERS(userId));
    //setLoading(false);
    return response;
  } catch (e) {
    //setLoading(false);
    errorNotifier(e.response?.data?.message);
  }
};

export const getFollowingUsers = async (userId) => {
  try {
    //console.log('2auth: ', userId)
    const response = await http.get(AUTH_ROUTES.GET_ALL_FOLLOWING_USERS(userId));
    return response; // Return the response data
  } catch (e) {
    errorNotifier(e.response?.data?.message);
    //throw e; // Rethrow the error to be handled by the caller if needed
  }
};


export const notInterested = async (payload, setLoading, setRefresh) => {
  try {
    const data = await http.post(AUTH_ROUTES.NOT_INTERESTED, payload);
    setLoading(false);
    successNotifier("You have removed this user from your feed");
    setRefresh({});
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.message);
    setRefresh({});
  }
};
